import React from "react";
import {
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
  required,
} from "react-admin";

const Form = (props) => (
  <SimpleForm {...props}>
    <ReferenceInput
      source="bookmaker_id"
      reference="bookmakers"
      fullWidth
      validate={required()}
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput
      source="user_id"
      reference="users"
      fullWidth
      validate={required()}
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  </SimpleForm>
);

export default Form;
